import { render, staticRenderFns } from "./google-material-icon.vue?vue&type=template&id=e024bb70&"
import script from "./google-material-icon.ts?vue&type=script&lang=ts&"
export * from "./google-material-icon.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports